import React from 'react';

type IconProps = { size?: number; color?: string };

export const FacebookIcon: React.FC<IconProps> = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M13.5 21v-8.2h2.75l.41-3.2h-3.16V7.5c0-.93.26-1.56 1.6-1.56h1.7V3.09C15.98 3.03 15.05 3 13.95 3c-2.3 0-3.87 1.4-3.87 3.98v2.62H7.32v3.2h2.76V21h3.42z" />
  </svg>
);

export const InstagramIcon: React.FC<IconProps> = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8}>
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.2" cy="6.8" r="0.9" fill={color} stroke="none" />
  </svg>
);

export const TwitterIcon: React.FC<IconProps> = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M18.9 3H21.7l-6.1 7 7.2 9.5h-5.6l-4.4-5.8-5 5.8H4.7l6.5-7.5L4.3 3H10l4 5.3L18.9 3zm-1 15h1.6L8.2 4.9H6.5L17.9 18z" />
  </svg>
);

export const YoutubeIcon: React.FC<IconProps> = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8}>
    <rect x="2.5" y="6" width="19" height="12" rx="3.5" />
    <path d="M10.5 9.7l5 2.3-5 2.3V9.7z" fill={color} stroke="none" />
  </svg>
);
